import {LOGGED_OUT, LOGGING_IN, LOGIN_FAILED, REFRESH_USER_DATA, SystemResult} from "./system-types";
import axios, {AxiosError, AxiosResponse} from "axios";
import {ServiceError} from "../models/responses";
import {getLoginDataUrl, loginUrl} from "../helpers/UrlHelper";
import {User} from "../types/user";
import Cookies from "js-cookie";
import {HIDE_LOGIN_MODAL} from "./modal-action-types";

export function doLoginAttempt(email: string, password: string): SystemResult<Promise<boolean>> {
    return (dispatch, getState) => {
        dispatch({type: LOGGING_IN})
        return axios.post(loginUrl, {
            email: email,
            password: password,
            app_version: "web_react",
            rememberMe: true
        }).then((response: AxiosResponse<User | ServiceError>) => {
            let data = response.data;
            if ("error" in data) {
                console.error(data)
                dispatch({type: LOGGED_OUT})
                return false
            } else {
                dispatch(doRefreshUserData()).finally()
                return true
            }
        }).catch((error: AxiosError<ServiceError>) => {
            if (error.response?.data.code === "album_locked") {
                // setAlbumLocked(true)
            }
            return false
        })
    }
}

export function doRefreshUserData(): SystemResult<Promise<void>> {
    return (dispatch, getState) => {
        return axios.get(getLoginDataUrl).then((response: AxiosResponse<User | ServiceError>) => {
            let data = response.data;
            if ("error" in data) {
                console.error(data)
                dispatch({type: LOGIN_FAILED})
            } else {
                dispatch({type: HIDE_LOGIN_MODAL})
                dispatch({type: REFRESH_USER_DATA, payload: data})
            }
        }).catch((error: AxiosError<ServiceError>) => {
            if (error.response?.data.code === "album_locked") {
                // setAlbumLocked(true)
                dispatch({type: LOGIN_FAILED})
            }
        })
    }
}

export function doLogout(): SystemResult<void> {
    return (dispatch, getState) => {
        Cookies.remove("PHPSESSID")
        Cookies.remove("rememberMe")
        dispatch({type: LOGGED_OUT})
    }
}